<template>
    <CRow>
        <CCol>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid'
                          :dataSource='data'
                          :allowFiltering='true'
                          :allowPaging='true'
                          :allowResizing='true'
                          :allowReordering='true'
                          :allowSorting='true'
                          :toolbar='toolbar'
                          :pageSettings='pageSettings'
                          :filterSettings='filterOptions'
                          :toolbarClick='toolbarClick'
                          :allowExcelExport='true'
                          :excelExportComplete='excelExportComplete'
                          :query='query'
                          :actionBegin ='actionBegin'
                          :actionComplete ='actionComplete'
                          :actionFailure ='actionFailure'
                          :enablePersistence ="true"
                          :recordDoubleClick="recordDoubleClick" width="100%" height="100%">
                    <e-columns>
                        <e-column field='tradingGroupId' headerText='Id' :isPrimaryKey='true' width="120" :visible='true' type="number"></e-column>
                        <e-column field='tradingGroupName' headerText='Name' :template='cTemplate' width=220 type="string"></e-column>
                        <e-column field='supplierName' headerText='Supplier Name' width=160 type="string"></e-column>
                        <e-column field='clientName' headerText='Client Name' width=300 type="string"></e-column>
                        <e-column field='utilityTypeName' headerText='Commodity' width=170 type="string"></e-column>
                        <e-column field='startDate' headerText='Start Date' width=170 type="date" :format="dateFormatOptions"></e-column>
                        <e-column field='endDate' headerText='End Date' width=170 type="date" :format="dateFormatOptions"></e-column>
                        <e-column field='riskManagerName' headerText='Risk Manager' width=170 type="string"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../common/gridOptions'
    import SyncHelper from '../common/syncfusion'
    import apis from '../common/network'
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import ATGColumnTemplate from '@/views/helperTemplates/ATGColumnTemplate.vue';

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    let DialogATGConfirmDelete = undefined;

    export default {
        name: 'TradingGroups',
        data() {
            return {
                data: SyncHelper.getDataManager("tradinggroup"),
                pageSettings: gridOptions.pageSettings,
                cTemplate: function () {
                    return {
                        template: {
                            extends: ATGColumnTemplate
                        }
                    }
                },
                toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddTradingGroup' },
                { text: 'Edit', tooltipText: 'Edit', prefixIcon: 'e-edit', id: 'EditTradingGroup' },
                { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteTradingGroup' },
                    'ExcelExport'],

                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' }
            }
        },
        mounted() {
            this.setToolbarVisibility();
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading',

            });
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id === 'AddTradingGroup') {
                    //this.$router.push({ name: "TradingGroup" });
                    this.$router.push({ name: 'TradingGroup' });
                }
                if (args.item.id === 'EditTradingGroup') {
                    let selectedTradingGroup = this.$refs.grid.getSelectedRecords();
                    if (selectedTradingGroup.length > 0) {
                        this.$router.push({
                            name: "TradingGroup",
                            params: { tradingGroupId: selectedTradingGroup[0].tradingGroupId }
                        });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a Contract first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' }
                        });
                    }
                }
                if (args.item.id === 'DeleteTradingGroup') {
                    var selectedTradingGroup = this.$refs.grid.getSelectedRecords();
                    if (selectedTradingGroup) {
                        apis.protectedApi(`utils/atgHasTrades?atgId=${selectedTradingGroup[0].tradingGroupId}`).then(atgHasTradesResponse => {
                            if (atgHasTradesResponse.data) {
                                DialogUtility.alert({
                                    title: 'Alert Dialog',
                                    content: "ATG can't be deleted because it has trades associated to it. Please delete the trades first.",
                                    position: { X: 700, Y: 200 },
                                    showCloseIcon: true,
                                    closeOnEscape: true,
                                    animationSettings: { effect: 'Zoom' }
                                });
                            } else {
                                apis.protectedApi(`reportTemplate/tradingGroup/${selectedTradingGroup[0].tradingGroupId}/exists`)
                                    .then(existsResponse => {
                                        if (existsResponse.data) {
                                            DialogATGConfirmDelete = DialogUtility.confirm({
                                                title: 'Warning!',
                                                okButton: { text: 'OK', click: this.confirmDeleteWithReports },
                                                cancelButton: { text: 'Cancel', click: this.cancelDelete },
                                                content: "The selected trading group is assigned to report template(s). Deleting it will delete all report templates that this trading group is assigned to.",
                                                position: { X: 700, Y: 200 },
                                                showCloseIcon: true,
                                                closeOnEscape: true,
                                                animationSettings: { effect: 'Zoom' },
                                                zIndex: 1100
                                            });
                                        } else {
                                            console.log("eto ga");
                                            DialogATGConfirmDelete = DialogUtility.confirm({
                                                title: 'Warning!',
                                                content: "Are you sure you want to delete this trading group?",
                                                okButton: { text: 'OK', click: this.confirmDelete },
                                                cancelButton: { text: 'Cancel', click: this.cancelDelete },
                                                position: { X: 700, Y: 200 },
                                                showCloseIcon: true,
                                                closeOnEscape: true,
                                                animationSettings: { effect: 'Zoom' }
                                            });
                                        }
                                    });
                            }
                        })
                        .catch(e => {
                            if (e.response) {
                                this.showErrorDialog("Something went wrong, please contact support.");
                            }
                        });
                    }
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    gridOptions.excelExport(args, "TradingGroups.xlsx", this.$refs);
                }
            },
            confirmDeleteWithReports: function () {
                let selectedTradingGroup = this.$refs.grid.getSelectedRecords();

                    apis.protectedApi.delete(`reportTemplate/tradingGroup/${selectedTradingGroup[0].tradingGroupId}/delete`)
                        .then(deleteReportTemplateResponse => {
                            apis.protectedApi.delete(`tradinggroup/${selectedTradingGroup[0].tradingGroupId}`)
                                .then(deleteTradingGroupResponse => {
                                    let message = { title: 'Success!', content: 'Trading group is deleted successfully', cssClass: 'e-toast-success' };
                                    this.$root.$emit('showToast', message);
                                    this.$refs.grid.refresh();
                                });
                            let message = { title: 'Success!', content: 'Report templates are deleted successfully', cssClass: 'e-toast-success' };
                            this.$root.$emit('showToast', message);
                            this.$refs.grid.refresh();
                        }).catch(e => {
                            DialogUtility.alert({
                                title: 'Alert Dialog',
                                content: e.response.data.message,
                                position: { X: 700, Y: 200 },
                                showCloseIcon: true,
                                closeOnEscape: true,
                                animationSettings: { effect: 'Zoom' },
                                zIndex: 1100
                            });
                        });
                DialogATGConfirmDelete.hide();
            },
            confirmDelete: function () {
                let selectedTradingGroup = this.$refs.grid.getSelectedRecords();

                apis.protectedApi.delete(`tradinggroup/${selectedTradingGroup[0].tradingGroupId}`)
                    .then(response => {
                        let message = { title: 'Success!', content: 'Trading group is deleted successfully', cssClass: 'e-toast-success' };
                        this.$root.$emit('showToast', message);
                        this.$refs.grid.refresh();
                        hideSpinner(document.getElementById('mainSpinner'));
                    });
                DialogATGConfirmDelete.hide();
            },
            cancelDelete: function () {
                this.$refs.grid.refresh();
                DialogATGConfirmDelete.hide();
            },
            recordDoubleClick: function (e) {
                this.$router.push({
                    name: "TradingGroup",
                    params: { tradingGroupId: e.rowData.tradingGroupId }
                });
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },

            actionBegin(args) {
                gridOptions.actionBegin(args);

            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            },
            setToolbarVisibility: function () {
                if (!this.$store.state.permissions["Permissions.TradingGroup.Create"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['AddTradingGroup'], false);
                }
                if (!this.$store.state.permissions["Permissions.TradingGroup.Delete"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['DeleteTradingGroup'], false);
                }
                if (!this.$store.state.permissions["Permissions.TradingGroup.Update"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['EditTradingGroup'], false);
                }
            },
        },
        computed: {
            query: function () {
                return new Query().addParams("userId", this.$store.state.loggedInUserId);
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>

</style>
<style>

</style>